import React from 'react';
import MetaTag from '@/components/ui/MetaTag';
import { ArticleList, Breadcrumb, Eyebrow, JournalShell, Section } from './components';
import type { JournalArticle } from './const';

export const JournalPressLayout = ({ articles, unavailable = false }: { articles: JournalArticle[]; unavailable?: boolean }) => (
  <JournalShell activeKey="bao-chi">
    <MetaTag title="Báo chí & tin tức tổng hợp" description="Tin tức từ các cơ quan báo chí được An Thư tóm lược, kèm liên kết nguồn gốc để bạn đọc và đối chiếu." />
    <Breadcrumb items={[{ label: 'Trang chủ', href: '/' }, { label: 'Tin tức & kiến thức', href: '/tin-tuc/' }, { label: 'Báo chí' }]} />
    <Section className="!tw-pt-6 md:!tw-pt-8">
      <Eyebrow>GÓC AN THƯ</Eyebrow>
      <h1 className="tw-font-jr tw-mt-4 tw-mb-4 tw-text-4xl md:tw-text-5xl tw-font-normal">Báo chí</h1>
      <p className="tw-max-w-[720px] tw-mb-10 tw-text-lg tw-text-jr-mute">Tin tức từ các cơ quan báo chí, được An Thư tóm lược và dẫn nguồn để bạn tiện theo dõi, đối chiếu.</p>
      {articles.length ? <ArticleList items={articles} /> : unavailable ? (
        <p className="tw-text-jr-mute" role="status">Chưa thể tải bài báo chí. Vui lòng thử lại sau.</p>
      ) : <p className="tw-text-jr-mute">Chưa có bài viết trong chuyên mục Báo chí.</p>}
    </Section>
  </JournalShell>
);
